import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ fontWeights, fontSizes }: Theme) => ({
  wrapper: {
    marginTop: '1.5rem',
  },
  title: {
    margin: '0 0 0.75rem',
    fontSize: fontSizes.lg,
    lineHeight: 1.4,
    fontWeight: fontWeights.medium,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: fontSizes.sm,
    fontWeight: fontWeights.regular,
    margin: '0.25rem 0',
  },
}));
